"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackType = void 0;
var FeedbackType;
(function (FeedbackType) {
    FeedbackType["Nps"] = "NPS";
    FeedbackType["Suggestion"] = "SUGGESTION";
})(FeedbackType || (exports.FeedbackType = FeedbackType = {}));
//# sourceMappingURL=feedback.js.map